import { render, staticRenderFns } from "./EventShell.vue?vue&type=template&id=6c1bd2e7&"
import script from "./EventShell.vue?vue&type=script&lang=js&"
export * from "./EventShell.vue?vue&type=script&lang=js&"
import style0 from "./styles/event-hub.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports